import Script from 'next/script'
import type { Thing, WithContext } from 'schema-dts'

import type { FacilityItemPage } from '@/lib/jsonLd/types'

interface JsonLdProps {
  data: WithContext<Thing> | FacilityItemPage
}

/**
 * Renders JSON-LD structured data in a script tag
 * XSS protection: escapes < characters to prevent script injection
 */
export const JsonLd = ({ data }: JsonLdProps) => {
  const jsonLdString = JSON.stringify(data).replace(/</g, '\\u003c')

  return (
    <Script
      id="json-ld"
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: jsonLdString }}
    />
  )
}
